export default __webpack_public_path__ + "static/media/GUIÓN SIMULADOR PUNCIÓN_1 (1).8e3e5c17.mp3";